import type { EngageTask } from '@/store/features/engage.feature';

// Client-side actionability guard for the task queue. Actionability is computed
// server-side (blocked_reason + actionable); this resolves those into a single
// display reason ('' = actionable) and gates every bulk action
// (start / complete / snooze) plus the ready/excluded split.
//
// Prefer the boolean but fall back to the string for safety; a completed task or
// a missing one is reported before the server flags.
export function taskBlocked(task: EngageTask | undefined): string {
  if (!task) return 'Task no longer available';
  if (task.status === 'completed') return 'Already completed';
  if (task.status === 'expired') return 'Expired';
  if (task.blocked_reason) return task.blocked_reason;
  return task.actionable ? '' : 'Not actionable';
}
